import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { onChangeCompetitorsRestrictionZonesFilter, onChangeCompetitorsRestrictionZonesOperatorsFilter } from '../../../ac/onChangeMapFilters';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { RESTRICTIONS_FILTER } from '../../../constants/filterStyles';
import { getStyleFilterItems } from '../../../constants/filterStylesResolver';
import { functionalAreasYandexUrentTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { DynamicAttributeFilter } from '../DynamicAttributeFilter';
import styles from '../FilterSidebar.module.css';

const RestrictionCompetitorsAreasFiltersComponent = ({
    mapFilters,
    onChangeCompetitorsRestrictionZonesFilter,
    onChangeCompetitorsRestrictionZonesOperatorsFilter,
}) => {
    const filter = RESTRICTIONS_FILTER;

    // ✅ НОВОЕ: Подтягиваем items через резолвер из стиля
    // Fallback на старую структуру для совместимости
    let items = filter.items;
    if (filter.style && filter.styleKey) {
        items = getStyleFilterItems(filter.style, filter.styleKey);
    }

    const { reduxPath } = filter;

    return (
        <div>
            <div className={styles.legHead}>{i18n._(RESTRICTIONS_FILTER.title)}:</div>
            <div className={styles.checkboxIconGrid}>
                {
                    items.map(({ value, label, color }) => (
                        <Fragment key={value}>
                            <CircleLegend
                                fill={color}
                                width="2vw"
                                height="2vw"
                                opacity="0.8"
                            />
                            <label htmlFor={value}>{i18n._(label)}</label>
                            <div>
                                <label className={styles.switch}>
                                    <input
                                        type="checkbox"
                                        name="competitorsRestrictionZones"
                                        id={value}
                                        checked={mapFilters[reduxPath].includes(value)}
                                        value={value}
                                        onChange={onChangeCompetitorsRestrictionZonesFilter}
                                    />
                                    <span className={classnames(styles.sliderRound, styles.slider)} />
                                </label>
                            </div>
                        </Fragment>
                    ))
                }
            </div>

            {/* Динамический фильтр операторов */}
            <DynamicAttributeFilter
                title={t`Операторы (зоны ограничений)`}
                attributeTypes={functionalAreasYandexUrentTypes}
                availableValues={mapFilters.competitorsRestrictionZonesAvailableOperators}
                disabledValues={mapFilters.competitorsRestrictionZonesOperatorsDisabled}
                onToggle={onChangeCompetitorsRestrictionZonesOperatorsFilter}
                inputNamePrefix="restriction-zones-operator"
            />
            <br/>
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(
    mapStateToProps,
    { onChangeCompetitorsRestrictionZonesFilter, onChangeCompetitorsRestrictionZonesOperatorsFilter }
)(RestrictionCompetitorsAreasFiltersComponent);

export const RestrictionCompetitorsAreasFilter = withDisplayedLayersCheck(ConnectedComponent, t`Зоны ограничений (конкуренты)`);
